import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  CPM_LIST_WORKSPACES,
  CPM_CREATE_WORKSPACE,
  CPM_UPDATE_WORKSPACE,
  CPM_GET_WORKSPACE,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/workspace';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmWorkspace;
const cpmWorkspace = (state = initialSettings, action) => {
  switch (action.type) {
    // CPM_LIST_WORKSPACES
    case CPM_LIST_WORKSPACES:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_LIST_WORKSPACES}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_LIST_WORKSPACES}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listWorkspaces.entries),
            pageNumber: _parseInt(action.data.listWorkspaces.pageNumber),
            pageSize: _parseInt(action.data.listWorkspaces.pageSize),
            totalEntries: _parseInt(action.data.listWorkspaces.totalEntries),
            totalPages: _parseInt(action.data.listWorkspaces.totalPages),
          },
        },
      };
    // CPM_GET_WORKSPACE
    case CPM_GET_WORKSPACE:
      return {
        ...state,
        get: {
          ...state.get,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_GET_WORKSPACE}_ERROR`:
      return {
        ...state,
        get: {
          ...state.get,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_WORKSPACE}_SUCCESS`:
      return {
        ...state,
        get: {
          ...state.get,
          loading: false,
          error: null,
          result: deserialize(action.data.getWorkspace),
        },
      };

    // CPM_CREATE_WORKSPACE
    case CPM_CREATE_WORKSPACE:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case `${CPM_CREATE_WORKSPACE}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_CREATE_WORKSPACE}_SUCCESS`:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // CPM_UPDATE_WORKSPACE
    case CPM_UPDATE_WORKSPACE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${CPM_UPDATE_WORKSPACE}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_WORKSPACE}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    default:
      return state;
  }
};

export default cpmWorkspace;



// WEBPACK FOOTER //
// ./reducers/cpm/workspace/workspace.js